import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoGraphicItems from 'eco-design/sections/eco-graphic-items';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function SectionList() {
    const { t } = useLang('theProduct.ListA2');

    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743077597604/list1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743077600444/list1_h5.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743077603239/list2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743077606091/list2_h5.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
    ];

    return (
        <div className={styles.SectionList}>
            <EcoSpace />
            <div className="eco-section-common">
                <div className="eco-section">
                    <div className="eco-section-title">{t('title')}</div>
                </div>
            </div>
            <EcoSpaceSmall />
            <EcoGraphicItems items={itemsA} theme="white" imgHeight="16-9" />
        </div>
    );
}
